import { LOAD_NOTIFICATION, NOTIFICATION_IS_READ, READ_NOTIFICATION, RECEIVE_NOTIFICATION, REMOVE_NOTIFICATION, REQUEST_NOTIFICATION } from "redux/constants/Notifications";

 
export const receiveNotification = (notification) => {
  return {
    type: RECEIVE_NOTIFICATION,
    notification,
  };
};
export const notificationIsRead = (notificationId) => {
  return {
    type: NOTIFICATION_IS_READ,
    notificationId,
  };
};
export const requestNotification = () => {
  return {
    type: REQUEST_NOTIFICATION,
  };
};
export const loadNotification = (data) => {
  return {
    type: LOAD_NOTIFICATION,
    data,
  };
};
export const readNotification = (notificationId) => {
  return {
    type: READ_NOTIFICATION,
    notificationId,
  };
};

export const removeNotification = (notificationId) => {
  return {
    type: REMOVE_NOTIFICATION,
    notificationId,
  };
};